import styled from 'styled-components';

const FolderIconSvg = styled.svg`
  width: 14px;
  height: 12px;
  flex-shrink: 0;
  color: var(--text-secondary);
`;

export default function FolderIcon() {
  return (
    <FolderIconSvg viewBox="0 0 20 17" fill="none" aria-hidden="true">
      <path
        d="M0.5 9.5V8.5C0.5 7.39543 1.39543 6.5 2.5 6.5H17.5C18.6046 6.5 19.5 7.39543 19.5 8.5V9.5M2.5 0.5H7.09194C7.60367 0.5 8.09594 0.696154 8.46743 1.04809L9.42146 1.95191C9.79295 2.30385 10.2852 2.5 10.7969 2.5H17.5C18.6046 2.5 19.5 3.39543 19.5 4.5V14.5C19.5 15.6046 18.6046 16.5 17.5 16.5H2.5C1.39543 16.5 0.5 15.6046 0.5 14.5V2.5C0.5 1.39543 1.39543 0.5 2.5 0.5Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </FolderIconSvg>
  );
}
